import {ReactNode} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Divider, view, Spinner} from '@sail/ui';
import {Code} from './Code';

const messages = defineMessages({
  yourCode: {
    id: 'conversations_ui.widget.requestACallTopBar.yourCode',
    description: "Label for the user's security code",
    defaultMessage: 'Your code',
  },
  yourCodeTooltip: {
    id: 'conversations_ui.widget.requestACallTopBar.yourCodeTooltip',
    description: "Tooltip explaining the user's security code",
    defaultMessage:
      "You'll be asked to provide this code to your support agent",
  },
  agentCode: {
    id: 'conversations_ui.widget.requestACallTopBar.agentCode',
    description: "Label for the agent's identification code",
    defaultMessage: 'Agent identification code',
  },
  agentCodeTooltip: {
    id: 'conversations_ui.widget.requestACallTopBar.agentCodeTooltip',
    description: "Tooltip explaining the agent's identification code",
    defaultMessage:
      'For your security, your support agent will provide you with this code to verify their identity',
  },
  codeRefresh: {
    id: 'conversations_ui.widget.requestACallTopBar.codeRefresh',
    description: 'Message indicating how often the call security codes refresh',
    defaultMessage: 'These codes refresh every 5 minutes.',
  },
});

const CodeRefreshMessage = () => (
  <view.div
    css={{
      marginTop: 'small',
      marginBottom: 'xsmall',
      font: 'label.small',
      textAlign: 'center',
    }}
  >
    <FormattedMessage {...messages.codeRefresh} />
  </view.div>
);

export const Codes = ({
  userCode,
  agentCode,
  error,
  loading,
}: {
  userCode: string;
  agentCode: string;
  error?: ReactNode;
  loading?: boolean;
}) => {
  if (loading && !userCode && !agentCode) {
    return (
      <view.div
        data-testid="loading-spinner"
        css={{
          width: 'fill',
          stack: 'y',
          alignX: 'center',
          alignY: 'center',
          marginY: 'medium',
        }}
      >
        <Spinner />
      </view.div>
    );
  }

  if (error) {
    return <view.div css={{marginY: 'medium'}}>{error}</view.div>;
  }

  return (
    <>
      <view.div
        css={{
          border: '1px solid',
          borderColor: 'border',
          borderRadius: 'medium',
          paddingY: 'small',
        }}
      >
        <Code
          label={<FormattedMessage {...messages.yourCode} />}
          code={userCode}
          tooltip={<FormattedMessage {...messages.yourCodeTooltip} />}
        />
        <Divider css={{marginY: 'small'}} />
        <Code
          label={<FormattedMessage {...messages.agentCode} />}
          code={agentCode}
          tooltip={<FormattedMessage {...messages.agentCodeTooltip} />}
        />
      </view.div>
      <CodeRefreshMessage />
    </>
  );
};
